import sponsoredTenants from "config/sponsoredTenants";
import { BRANDING_URL } from "constants/";
import { Image } from "expo-image";
import { TenantSubdomain, TenantType } from "features/types";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import React from "react";
import { View } from "react-native";
import { svgURL } from "utils/fileUtils";

export const SponsorLogo = ({
  tenantType,
  tenantSubdomain,
}: {
  tenantType: TenantType;
  tenantSubdomain: TenantSubdomain;
}) => {
  const getSponsorImage = () => {
    return `${BRANDING_URL}/logos/${tenantSubdomain}_sponsor.png`;
  };

  return (
    <Image
      responsivePolicy="initial"
      source={{ uri: getSponsorImage() }}
      style={{ height: 100, width: 100 }}
    ></Image>
  );
};

const TenantLogo = ({
  isDarkBackground = true,
  height = 100,
  width = 100,
}: {
  isDarkBackground?: boolean;
  height?: number;
  width?: number;
}) => {
  const { data: branding } = useFetchTenantBrandingQuery();
  if (!branding) return null;

  const { type, subdomain, name } = branding;
  const tenantLogo = svgURL(name, isDarkBackground);

  const isSponsored = sponsoredTenants.includes(subdomain!);
  return (
    <View>
      <Image
        source={{ uri: tenantLogo }}
        style={{ height, width }}
        contentFit="contain"
        responsivePolicy="initial"
      ></Image>
      {isSponsored && (
        <SponsorLogo
          tenantSubdomain={subdomain}
          tenantType={type}
        ></SponsorLogo>
      )}
    </View>
  );
};

export default TenantLogo;
